import { render } from "./ManifestDashboard.vue?vue&type=template&id=21d2f1ce&scoped=true"
import script from "./ManifestDashboard.vue?vue&type=script&lang=js"
export * from "./ManifestDashboard.vue?vue&type=script&lang=js"

import "./ManifestDashboard.vue?vue&type=style&index=0&id=21d2f1ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21d2f1ce"]])

export default __exports__